
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHeroSection from './components/AboutHeroSection';
import OurStorySection from './components/OurStorySection';
import FounderSection from './components/FounderSection';
import ValuesSection from './components/ValuesSection';
import QCTOSection from './components/QCTOSection';
import PartnerCTASection from './components/PartnerCTASection';

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AboutHeroSection />
        <OurStorySection />
        <FounderSection />
        <ValuesSection />
        <QCTOSection />
        <PartnerCTASection />
      </main>
      <Footer />
    </div>
  );
}
